import * as React from 'react';
import { createVideoPreviewUrl, createVideoUrl } from '../../../cloudinary';
import AnswerVideoFrame from '../../../components/AnswerVideoFrame';
import { ApplicationQuestionAnswer } from '../types';

interface AnswerVideoBoxProps {
    answer: ApplicationQuestionAnswer | undefined;
}

const AnswerVideoBox: React.FC<AnswerVideoBoxProps> = ({ answer }) => {
    const answerVideoLink = answer && answer.videoId && createVideoUrl(answer.videoId);
    return (
        <div>
            {answerVideoLink ? (
                <AnswerVideoFrame>
                    <h2>Question</h2>
                    <p>{answer!.question}</p>
                    <h2>Video Answer</h2>
                    <video
                        key={answer!.videoId}
                        controls={true}
                        autoPlay={false}
                        poster={createVideoPreviewUrl(answer!.videoId!, 'w_480')}
                    >
                        <source src={answerVideoLink} type="video/mp4" />
                    </video>
                </AnswerVideoFrame>
            ) : (
                <AnswerVideoFrame>
                    <h2>Video Answer</h2>
                    <p>
                        You can't see anything from this candidate yet. Please wait until the candidate has submitted
                        her/his recordings.
                    </p>
                </AnswerVideoFrame>
            )}
        </div>
    );
};

export default AnswerVideoBox;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/AnswerVideoBox.tsx